import { CurrencyUnit } from "@faire/web-api--source/faire/currency/CurrencyUnit";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";

export const RETAIL_PRICE_THRESHOLD = IFaireMoney.build({
  amount_cents: 100000,
  currency: CurrencyUnit.USD,
});
